import type { IconData } from '@stacksjs/iconify-core'

export const blind: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m374.906 253.877l11.36-10.328l-109.911-120.9h-68.492L163.585 151.4A60.36 60.36 0 0 0 136 202.2V274h32v-71.8a28.48 28.48 0 0 1 13.013-23.967L208 160.712v93.836l105.7 220.381h32.942L272.714 315.7V166.214l74.628 82.086l82.409 226.626h25.537ZM214.7 96.861a34.081 34.081 0 1 0-10.871-24.949A33.96 33.96 0 0 0 214.7 96.861\"/><path fill=\"currentColor\" d=\"M132.796 474.929h34.465l57.514-143.785l-18.793-39.181z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default blind
